import React, { useEffect, useState } from "react";
import { ApiService } from "../components/Common/ApiService";

import Homapages from "../pages/Hompages";
import Product from "../pages/product/index";
import Invoice from "../pages/invoice/index";
import LoginPages from "../pages/authentication/loginPages";
import ForgotPasswordPages from "../pages/authentication/forgotPasswordPages";
import { useNavigate, useParams } from "react-router";
import ProfilePages from "../pages/profile";
import CheckInvoice from "../pages/invoice/CheckInvoice";
import ClaimVoucher from "../pages/invoice/ClaimVoucher";
import TermAndCondition from "../pages/utils/TermAndCondition";
import Privacy from "../pages/utils/Privacy";
import AllGames from "../pages/allgames";
import HistoryOrder from "../pages/profile/HistoryOrder";
import LogSaldo from "../pages/profile/LogSaldo";
import DaftarLayanan from "../pages/utils/DaftarLayanan";
import BlogPages from "../pages/Blog";
import DetailBlogPages from "../pages/Blog/detailBlog";
import SearchBlog from "../pages/Blog/searchBlog";
import About from "../pages/utils/About";
import Faq from "../pages/utils/Faq";

import { ReactComponent as NotFoundIcon } from "../assets/icon/transaction_not_found.svg";

import MembershipPages from "../pages/profile/Membership";
import TopupSaldo from "../pages/profile/TopupSaldo";
import ListPoint from "../pages/profile/ListPoint";
import GiftCard from "../pages/profile/GiftCard";
import CheckMLPage from "../pages/utils/CheckML";
function DynamicProductPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [productData, setProductData] = useState(null);

  useEffect(() => {
    let product = localStorage.getItem('isProduct');

    if (product) {
      try {
        const parsedProduct = JSON.parse(product);
        setProductData(parsedProduct);
      } catch (error) {
        console.error('Failed to parse isProduct:', error);
        setProductData(null);
      }
    } else {
      console.log('isProduct is not available in localStorage. Redirecting to product page.');
      fetchDataProduct()
    }
  }, [navigate]);

  const fetchDataProduct = async () => {
    try {
      const response = await ApiService({
        baseurl: "user/kategori",
        method: "GET",
        XGORDON: "KATEGORI"
      });
      if (response?.statusCode === 200) {
        const allCategory = response?.result.data.reduce((accumulator, current) => {
          return [...accumulator, ...current.kategori];
        }, []);
        const listProduct = allCategory.map((item) => {
          return {
            ...item,
            jenis: response?.result.data.find((jenis) =>
              jenis.kategori.some((kategori) => kategori.nama === item.nama)
            ).jenis,
          };
        });
        const slugArray = listProduct.map(item => item.slug);
        localStorage.setItem('isProduct', JSON.stringify(slugArray));
        window.location.reload();
      } else {
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const slugToComponent = React.useMemo(() => {
    const components = {};
    if (productData) {
      productData.forEach(slug => {
        components[slug] = <Product slug={slug} />;
      });
    }
    return components;
  }, [productData]);

  const selectedComponent = productData ? slugToComponent[slug] : null;

  return selectedComponent ? selectedComponent : (
    <div className="flex min-w-full min-h-screen items-center justify-center flex-col p-4 font-inter">
      <div className="gap-3 flex flex-col items-center container max-w-6xl">
      <NotFoundIcon className=" h-64 aspect-square"/>
        <span className="text-3xl font-bold text-center">Page Not Found</span>
        <span className="text-base text-center">
          Page yang anda akses tidak tersedia
        </span>
      </div>
    </div>
  );
}

const userRoutes = [
  { path: "/login", component: <Homapages /> },
  { path: "/me", component: <ProfilePages /> },
  { path: "/claim-voucher", component: <ClaimVoucher /> },
  { path: "/history-order", component: <HistoryOrder /> },
  { path: "/logsaldo", component: <LogSaldo /> },
  { path: "/membership", component: <MembershipPages /> },
  { path: "/topup", component: <TopupSaldo /> },
  { path: "/tukarpoin", component: <ListPoint /> },
  { path: "/gift-card", component: <GiftCard /> },

];
const nonUserRoutes = [
  { path: "/", component: <Homapages /> },
  { path: "/beli/:slug", component: <DynamicProductPage /> },
  { path: "/invoice/:slug", component: <Invoice /> },
  { path: "/cek-invoice", component: <CheckInvoice /> },
  { path: "/term-and-conditional", component: <TermAndCondition /> },
  { path: "/privacy", component: <Privacy /> },
  { path: "/about", component: <About /> },
  { path: "/allgames", component: <AllGames /> },
  { path: "/daftar-layanan", component: <DaftarLayanan /> },
  { path: "/Faq", component: <Faq /> },
  { path: "/blog", component: <BlogPages /> },
  { path: "/news/:slug", component: <DetailBlogPages /> },
  { path: "/search-blog/:slug", component: <SearchBlog /> },
  { path: "/check-ml", component: <CheckMLPage /> },

];

const authRoutes = [
  { path: "/login", component: <LoginPages /> },
  { path: "/forgotpassword", component: <ForgotPasswordPages /> },
];

export { userRoutes, authRoutes, nonUserRoutes };
